module.exports = [ '$scope', 'ngDialog', function($scope, ngDialog){
  this.openContact = function() {
    ngDialog.open({
      template: 'templates/popup-contact.jade',
      scope: $scope,
      className: 'ngdialog-contact',
    });

    (ga||angular.noop)('send', 'pageview', '/contact');
  };

  this.navigate = function(link) {
    window.location.href = link;
  };
}];


//////////////////
// WEBPACK FOOTER
// ./assets/app/app.controller.js
// module id = 4
// module chunks = 0